import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';

var Config = require('../../../../config');

class ModalAddProfile extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.validateAnaliticalTest = this.validateAnaliticalTest.bind(this);
		
		this.state = {
		    show: false,
		    items:[],
		    profile_name:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(analitical_profile_id, profile_name) {
		this.setState({show: true});
		fetch(Config.default.apiGateway.URL+'analitical_test/by_profile?analitical_profile_id='+analitical_profile_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error!', error, 'error');
              });
	        }
	    })
		.then(response =>{
			this.setState({items:response});
		}) 
	}

	validateAnaliticalTest(){
		var obj = {}, res = [], rejected = [], flag_complete = true;
		this.state.items.map((item, index) =>{
			if(this.props.checkList(item.analitical_test.id) && !this.props.existTest(item.analitical_test.id.toString())){
				var isInputValid = this.props.showCtrlError('analitical_test'+item.analitical_test.id);
				if(isInputValid){
					obj = {};
					obj.value = document.getElementById("analitical_test"+item.analitical_test.id).value;
					obj.analitical_test = item.analitical_test;
					res.push(obj);
				}else{
					flag_complete = false;
				}
			}else{
				rejected.push(item.analitical_test.name);
			}	
		});
		if(flag_complete){
			if(rejected.length>0){
				var msg = "<label>Las siguientes pruebas ya existen y no serán agregadas:</label><div style='text-align:left'> ";
				for(var i =0;i < rejected.length;i++){
					msg+="<span style='text-align:left;padding-left:45px'>*"+rejected[i]+"</span><br/>";
				}
				msg+="<div>";
				swal({
				        title: '¿Desea continuar?',
				        html:true,
				        text: msg,
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
				    }, function (isConfirm) {
				        if (isConfirm) {
				        	this.props.save(res);
				        	this.handleClose();
				        }else{
				        	return;
				        }
				    }.bind(this));
			}else{
				this.props.save(res);
				this.handleClose();
			}
		}
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Agregar Perfil Analítico</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		{this.state.items.map((item, index) =>{            
							return(	
								<div key={index} className="col-xs-12" style={{paddingTop:"3px",paddingLeft:"20px",paddingRight:"20px"}}>
						          	<div className="col-xs-8"  style={{padding:'0px'}}>
				        				<span>{item.analitical_test.name}:</span>
				        			</div>
				        			{item.type !== "CUALITATIVO"?
					        			<div className="col-xs-4" style={{padding:"0px"}}>
					        				<input type="text" step="0.001" className="form-control"  required 
					        					id={"analitical_test"+item.analitical_test.id} name={"analitical_test"+item.analitical_test.id}/>
					        			</div>
				        			:<div className="col-xs-4" style={{padding:"0px"}}>
				        					<select className="form-control" id={"analitical_test"+item.analitical_test.id}
								              	name={"analitical_test"+item.analitical_test.id} required>
								              	<option value="">Seleccionar...</option>
								                {
									                item.results.map(function(t) {
									                  return <option key={t.id} value={t.value} >{t.value} </option>;
									                })
								            	}
							              	</select>
				        			</div>
					        		}
				        		</div>
				        	)
				        })}
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.add')} onClick={this.validateAnaliticalTest}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalAddProfile);